
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLogoOpenbridge as ObiLogoOpenbridgeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-logo-openbridge.js';
 
 
 

 
 export const ObiLogoOpenbridge = createComponent({
   react: React,
   tagName: 'obi-logo-openbridge',
   elementClass: ObiLogoOpenbridgeElement,
   events: {
     
   }
  });
 
 